<style scoped>

</style>

<template>
    <div class="l-wrap">
        <div class="l-constrained l-content">
            <div class="container-fluid" style="text-align: center;">
                <div v-if="arePushNotificationsSupported">
                    <h1>Click the button below to enable browser notifications</h1>
                    <div v-if="statusMessage" :class="['alert', 'alert-dismissible', (statusMessage.type == 'error') ? 'alert-danger' : 'alert-info']">
                        <span class="close" aria-label="close" v-on:click="statusMessage = null">&times;</span>
                        <p v-html="statusMessage.text"></p>
                    </div>
                    <div v-show="swRegistration" style="text-align: center">
                        <button class="btn btn-info btn-lg" @click="askForPermissions">Get Notifications</button>
                    </div>
                </div>
                <div v-else>
                    <h1>We are sorry your browser doesn't support browser notifications, please contact our support</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            saveUserSubscriptionUrl: String,
            saveNotificationsBlockedUrl: String,
            employerId: String,
            recruiterId: String,
            userId: String,
            publicKey: String,
        },
        data() {
            return {
                statusMessage: null,
                swRegistration: null
            };
        },
        computed: {
            arePushNotificationsSupported(){
                return ('serviceWorker' in navigator) && ('PushManager' in window);
            }
        },
        methods: {
            askForPermissions(){
                if(!this.swRegistration){
                    console.error("notifications-service-worker is not registered");
                    return;
                }
                this.showInfo('Thank you, please allow notification in the dialog above. <br /> If you don\'t see it, please visit <a href="https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=en" target="_blank">this site</a> for more details.');
                Notification.requestPermission()
                    .then((result) => {
                        if (result !== 'granted') {
                            this.showError('You have blocked browser notifications or you are in an anonymous window. Please contact support, or visit <a href="https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=en" target="_blank">this site</a> to enable it.');
                            this.saveNotificationsBlocked();
                        }
                        else{
                            const subscribeOptions = {
                                userVisibleOnly: true,
                                applicationServerKey: this.urlBase64ToUint8Array(this.publicKey)
                            };
                            this.swRegistration.pushManager.subscribe(subscribeOptions)
                                .then((pushSubscription) => {
                                    this.saveUserSubscription(pushSubscription)
                                })
                                .catch((err) => {
                                    this.showError("We were not able to register you to push notifications. Please contact support.");
                                    console.error("Subscription to push notifications failed. Err:" + err)
                                });
                        }
                    })
            },
            registerServiceWorker(){
                var workerName = '/notifications-service-worker.js';
                navigator.serviceWorker.register(workerName)
                    .then((registration) => {
                        this.swRegistration = registration;
                    })
                    .catch((err) => {
                        this.showError("Registration to browser notifications failed. Please contact support.");
                        console.error("Registration to browser notifications failed Err:" + err)
                    });
            },
            saveNotificationsBlocked(){
                var params = {
                    deviceInfo: '',
                    employerId: this.employerId,
                    recruiterId: this.recruiterId,
                    userId: this.userId
                };
                axios.post(this.saveNotificationsBlockedUrl, params);
            },
            saveUserSubscription(userData){
                var params = {
                    userSubscription: JSON.stringify(userData),
                    deviceInfo: '',
                    employerId: this.employerId,
                    recruiterId: this.recruiterId,
                    userId: this.userId
                };
                axios.post(this.saveUserSubscriptionUrl, params)
                    .then((response) => {
                        this.showInfo("Thank you, you will be notified about new Leads.");
                    })
                    .catch((err) => {
                        this.showError("We were not able to register you to push notifications. Please contact support.");
                    });
            },
            urlBase64ToUint8Array(base64String) {
                const padding = '='.repeat((4 - base64String.length % 4) % 4);
                const base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/');

                const rawData = window.atob(base64);
                const outputArray = new Uint8Array(rawData.length);

                for (let i = 0; i < rawData.length; ++i) {
                    outputArray[i] = rawData.charCodeAt(i);
                }
                return outputArray;
            },
            onNoClicked(){
                window.location.href = '/';
            },
            showError(message){
                this.statusMessage = {
                    type: 'error',
                    text: message
                }
            },
            showInfo(message){
                this.statusMessage = {
                    type: 'info',
                    text: message
                }
            },

        },
        mounted: function(){
            this.registerServiceWorker();
        }
    }
</script>
